const mainNavConfig = [
  {
    label: "Overview",
    route: "overview",
  },
  {
    label: "Labs",
    route: "labs",
  },
  {
    label: "Active Meds",
    route: "meds",
  },
  {
    label: "Vitals",
    route: "vitals",
    subnavItems: [],
  },
  {
    label: "Monitor",
    route: "monitor",
  },
  {
    label: "Documents",
    route: "documents",
    subnavItems: [
      {
        label: "Recent",
        route: "documents",
        exact: false,
      },
    ],
  },
  {
    label: "ECGs",
    route: "ecgs",
  },
  {
    label: "Imaging",
    route: "images",
  },
  {
    label: "Vents",
    route: "ventilator",
    subnavItems: [
      {
        label: "Grid",
        route: `ventilator`,
      },
      {
        label: "Events",
        route: "ventilator/events",
      },
    ],
  },
];

export default mainNavConfig;
